// extracted by mini-css-extract-plugin
module.exports = {"root":"cookie-notification_root__N0HPO","button":"cookie-notification_button__0txx7"};